import { visionURL } from "../config/environment";
import { useEffect, useState } from "react";
import Jsona from "jsona";
import JsonApiService from "../services/jsonapiService";

const dataFormatter = new Jsona();

const kingsleyApiService = async () =>
  new JsonApiService("rating_questions", {
    baseUrl: `${visionURL}/kingsley`,
    credentials: "include"
  });

export const useKingsLink = () => {
  const [kingsLink, setKingsLink] = useState();
  const [status, setStatus] = useState("loading");

  // Get auth token from kingsley
  const getKingsLink = async () => {
    const response = await fetch(`${visionURL}/kingsley/integration_link`, {
      credentials: "include"
    });
    if (response.ok) {
      setKingsLink((await response.json()).Data[0].PortalLink);
      setStatus("Success");
    } else {
      setStatus("Failed");
    }
  };

  useEffect(() => {
    getKingsLink();
  }, []);

  // If Auth open in new tab
  const openKingsLink = () => {
    var win = window.open(kingsLink, "_blank");
    win.focus();
  };

  return { kingsStatus: status, openKingsLink: openKingsLink };
};

export const useKingsleyKpis = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [ratingQuestions, setRatingQuestions] = useState(false);

  const fetchKingsleyRatingQuestions = async () => {
    setIsLoading(true);

    const service = await kingsleyApiService();
    const response = await service.all().then(response => response.json());

    setIsLoading(false);
    setRatingQuestions(response);
  };

  useEffect(() => {
    fetchKingsleyRatingQuestions();
  }, []);

  return {
    ratingQuestions:
      ratingQuestions && !ratingQuestions.message
        ? dataFormatter.deserialize(ratingQuestions)
        : ratingQuestions,
    isLoading
  };
};
